module.exports = __webpack_public_path__ + "static/media/finland.a5471749.svg";